import "bootstrap/dist/css/bootstrap.css";
import "./styles.css";
import React from "react";
import micrometerImage from "./Geometry_1.png"
import { render } from "react-dom";
import { register } from 'register-service-worker'
// import PwaInstallPopupIOS from 'react-pwa-install-ios';
 
register('/service-worker.js', {
  registrationOptions: { scope: './' },
  ready (registration) {
    console.log('Service worker is active.')
  },
  registered (registration) {
    console.log('Service worker has been registered.')
  },
  cached (registration) {
    console.log('Content has been cached for offline use.')
  },
  updatefound (registration) {
    console.log('New content is downloading.')
  },
  updated (registration) {
    console.log('New content is available; please refresh.')
  },
  offline () {
    console.log('No internet connection found. App is running in offline mode.')
  },
  error (error) {
    console.error('Error during service worker registration:', error)
  }
})


class MicrometerCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      configMinimized: true,
      currentMM: 1,
      currentDistanceIndex: 0,
      distances: ["LE", "MD", "TE"],
      currentDistance: "LE",
      tipAmount: 0,
      totalAmount: 0,
      initialValue: "",
      steps: [
        {
          id: 1,
          name: "Step 1",
          description: "Move Mic 1 to where LE indicator reads: ",
          value: null
        },
        {
          id: 2,
          name: "Step 2",
          description: "Move Mic 2 to where Middle indicator reads: ",
          value: null
        },
        {
          id: 3,
          name: "Step 3",
          description: "Move Mic 3 to where TE indicator reads: ",
          value: null
        }
      ],
      currentReading: {
        1: "",
        2: "",
        3: ""
      },
      desiredReading: {
        1: "",
        2: "",
        3: ""
      },
      currentIndicator: {
        id: "LE",
        distances: {
          total: 39.8,
          1: 70.3,
          2: -66.3,
          3: -10.4
        }
      },
      currentMicrometer: {
        id: 1,
        distances: {
          total: 144.2,
          LE: 103.4,
          MD: 69.6,
          TE: 31.2
        },
        changeToMake: null
      },
      indicatorDistances: [
        {
          id: "LE",
          num: 1,
          distances: {
            total: 39.8,
            1: 70.3,
            2: -66.3,
            3: -10.4
          }
        },
        {
          id: "MD",
          num: 2,
          distances: {
            total: 36.6,
            1: -13.7,
            2: 85,
            3: -14.6
          }
        },
        {
          id: "TE",
          num: 3,
          distances: {
            total: 79.7,
            1: -33.3,
            2: 29.7,
            3: 130
          }
        }
      ],
      micrometers: [
        {
          id: 1,
          distances: {
            total: 144.2,
            LE: 103.4,
            MD: 69.6,
            TE: 31.2
          },
          changesToMake: [
            { id: 1, name: "LE", value: null },
            { id: 2, name: "MD", value: null },
            { id: 3, name: "TE", value: null }
          ],
          changeToMakeTotal: null
        },
        {
          id: 2,
          distances: {
            total: 100,
            LE: 13.9,
            MD: 50.8,
            TE: 14.7
          },
          changesToMake: [
            { id: 1, name: "LE", value: null },
            { id: 2, name: "MD", value: null },
            { id: 3, name: "TE", value: null }
          ],
          changeToMakeTotal: null
        },
        {
          id: 3,
          distances: {
            total: 120,
            LE: 18.2,
            MD: 1,
            TE: 75
          },
          changesToMake: [
            { id: 1, name: "LE", value: null },
            { id: 2, name: "MD", value: null },
            { id: 3, name: "TE", value: null }
          ],
          changeToMakeTotal: null
        }
      ]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleReadingChange = this.handleReadingChange.bind(this);
    this.changeTip = this.changeTip.bind(this);
    this.tipPlusOne = this.tipPlusOne.bind(this);
    this.tipMinusOne = this.tipMinusOne.bind(this);
    this.changePivotLines = this.changePivotLines.bind(this);
    this.incrementDistanceIndex = this.incrementDistanceIndex.bind(this);
    this.decrementDistanceIndex = this.decrementDistanceIndex.bind(this);
    this.calculateChangesToMake = this.calculateChangesToMake.bind(this);
    this.minimize = this.minimize.bind(this);
  }

  minimize() {
    let newVal = !this.state.configMinimized;
    this.setState({ configMinimized: newVal });
  }

  changeTip(currentMM) {
    //check bounds and exit if outside
    if (currentMM < 1) return;
    if (currentMM > this.state.micrometers.length) return;

    //find the new micrometer
    var currentMicrometer = this.state.micrometers.find((obj) => {
      return obj.id === currentMM;
    });

    this.setState({
      currentMM: currentMM,
      currentMicrometer: currentMicrometer
    });
  }

  tipPlusOne() {
    this.changeTip(this.state.currentMM + 1);
  }

  tipMinusOne() {
    this.changeTip(this.state.currentMM - 1);
  }

  changePivotLines(currentDistanceIndex) {
    //check bounds and exit if outside
    if (currentDistanceIndex < 0) return;
    if (currentDistanceIndex >= this.state.distances.length) return;

    let distanceMap = this.state.distances;
    console.log(distanceMap);
    console.log(currentDistanceIndex);
    let newCurrentDistance = distanceMap[currentDistanceIndex];

    //find the new micrometer
    var newCurrentIndicator = this.state.indicatorDistances.find((obj) => {
      return obj.id === newCurrentDistance;
    });

    this.setState({
      currentIndicator: newCurrentIndicator,
      currentDistance: newCurrentDistance,
      currentDistanceIndex: currentDistanceIndex
    });
  }

  incrementDistanceIndex() {
    this.changePivotLines(this.state.currentDistanceIndex + 1);
  }

  decrementDistanceIndex() {
    this.changePivotLines(this.state.currentDistanceIndex - 1);
  }

  // calculateSteps() {
  //   this.state.micrometers.forEach((m) => {
  //     let effect = 0;
  //     var restOfMicrometers = m.changesToMake.find(function (obj) {
  //       return obj.id === m.id;
  //     });
  //   });
  // }

  calculateChangesToMake() {
    //calculate the changes to make by micrometer and indicator
    var updatedMicrometers = [];
    this.state.micrometers.forEach((m) => {
      var updatedChangeToMakeTotal = 0;
      var updatedChangesToMake = [];
      m.changesToMake.forEach((c) => {
        let difference =
          this.state.desiredReading[c.id] - this.state.currentReading[c.id];
        let iDistance = this.state.indicatorDistances.find((i) => {
          return i.num === c.id;
        });
        var effect = iDistance.distances[m.id] / iDistance.distances["total"];
        c["value"] = difference * effect;
        updatedChangeToMakeTotal += c["value"];
        c.value = c.value.toFixed(3);
        updatedChangesToMake.push(c);
      });
      m.changesToMake = updatedChangesToMake;
      m.changeToMakeTotal = updatedChangeToMakeTotal.toFixed(4);
      updatedMicrometers.push(m);
    });
    let currentMM = this.state.currentMM;
    let currentMicrometer = updatedMicrometers.find((m) => {
      return m.id === currentMM;
    });

    //updateStep 1
    var updatedSteps = [];
    var s1 = this.state.steps.find((s) => {
      return s.id === 1;
    });
    var m1 = updatedMicrometers.find((m) => {
      return m.id === s1.id;
    });
    s1["value"] =
      (m1.distances["LE"] / m1.distances["total"]) * m1.changeToMakeTotal +
      Number(this.state.currentReading[1]);
    s1.value = Number(s1.value).toFixed(3);
    updatedSteps.push(s1);

    //updateStep 2
    var s2 = this.state.steps.find((s) => {
      return s.id === 2;
    });
    var m2 = updatedMicrometers.find((m) => {
      return m.id === s2.id;
    });
    s2["value"] =
      (m1.distances["MD"] / m1.distances["total"]) * m1.changeToMakeTotal +
      (m2.distances["MD"] / m2.distances["total"]) * m2.changeToMakeTotal +
      Number(this.state.currentReading[2]);
    s2.value = Number(s2.value).toFixed(3);
    updatedSteps.push(s2);

    console.log(m1.changeToMakeTotal);

    //update step 3
    var s3 = this.state.steps.find((s) => {
      return s.id === 3;
    });
    s3["value"] = Number(this.state.desiredReading[3]).toFixed(3);
    updatedSteps.push(s3);

    //update the current micrometer in state/config

    this.setState({
      micrometers: updatedMicrometers,
      steps: updatedSteps,
      currentMicrometer: currentMicrometer
    });
  }

  handleReadingChange(e) {
    const typeToUpdate = e.target.id.split("-")[1];
    const idToUpdate = e.target.id.split("-")[0];
    var newValue = e.target.value;
    var updatedCurrentReading = this.state.currentReading;
    var updatedDesiredReading = this.state.desiredReading;

    if (newValue[0] === "." && !isNaN(newValue.split(".")[1]))
      newValue = "0" + newValue;

    var i = this.state.distances.indexOf(idToUpdate) + 1;

    if (typeToUpdate === "current") updatedCurrentReading[i] = newValue;
    if (typeToUpdate === "desired") updatedDesiredReading[i] = newValue;

    if (!isNaN(newValue)) {
      this.setState(
        {
          currentReading: updatedCurrentReading,
          desiredReading: updatedDesiredReading
        },
        () => {
          let cr = this.state.currentReading;
          let dr = this.state.desiredReading;
          if (
            cr[1] !== "" &&
            cr[2] !== "" &&
            cr[3] !== "" &&
            dr[1] !== "" &&
            dr[2] !== "" &&
            dr[3] !== ""
          ) {
            this.calculateChangesToMake();
          }
        }
      );
    }
  }

  handleChange(e) {
    //find the new micrometer
    const index = this.state.currentMM;
    const typeToUpdate = e.target.id.split("-")[1];
    const idToUpdate = e.target.id.split("-")[0];
    var newValue = e.target.value;
    var attrSelect = idToUpdate.toString();

    if (newValue[0] === "." && !isNaN(newValue.split(".")[1]))
      newValue = "0" + newValue;

    if (typeToUpdate === "micrometer") {
      //remove the current micrometer from the array and get the current one
      var restOfMicrometers = this.state.micrometers.filter(function (obj) {
        return obj.id !== index;
      });
      var updatedMicrometer = this.state.currentMicrometer;

      updatedMicrometer.distances[attrSelect] = newValue;

      restOfMicrometers.push(updatedMicrometer);

      if (!isNaN(newValue)) {
        this.setState({
          currentMicrometer: updatedMicrometer,
          micrometers: restOfMicrometers
        });
      }
    } else if (typeToUpdate === "indicator") {
      console.log(idToUpdate);
      //var distanceIndex = this.state.currentDistanceIndex;
      var distanceID = this.state.currentDistance;
      var restOfDistances = this.state.indicatorDistances.filter(function (
        obj
      ) {
        return obj.id !== distanceID;
      });

      var updatedDistance = this.state.currentIndicator;
      updatedDistance.distances[idToUpdate] = newValue;

      restOfDistances.push(updatedDistance);
      console.log(updatedDistance);

      if (!isNaN(newValue)) {
        this.setState({
          currentIndicator: updatedDistance,
          currentDistance: distanceID,
          indicatorDistances: restOfDistances
        });
      }
    }
  }

  render() {
    const divStyle = {
        minHeight: "11rem"
      },
      tipInput = `${this.state.currentMM}`,
      currentDistance = `${this.state.currentDistance}`,
      micrometerName = `Mic ${this.state.currentMicrometer.id}`;

    return (
      <div className="container">
        <button className="btn btn-secondary inputMicroAttr" onClick={this.minimize}>
          {this.state.configMinimized ? (
            <div className="inputMicroAttr">Open Configuration</div>
          ) : (
            <div>Minimize Configuration</div>
          )}
        </button>
        
        <div>
          <div className={this.state.configMinimized ? "hidden" : ""}>
            <h3>Mircometer Configuration</h3>
            <div className="row"></div>
            <div className="row">
              <div className="col">
                <div className="selectMicrometer inputMicroAttr">
                  <label htmlFor="tip-percent">Select Micrometer</label>
                  <div className="input-group mb-3 ">
                    <div className="input-group-prepend">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={this.tipMinusOne}
                      >
                        -
                      </button>
                    </div>
                    <input
                      type="number"
                      className="form-control"
                      id="tip-percent"
                      value={tipInput}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={this.tipPlusOne}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <form class="text-center">
                  Distance from <b> micrometer</b> pivot lines
                  <br />
                  <div>
                    <label htmlFor="Total"> </label>
                    <div className="input-group inputMicroAttr ">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          {micrometerName}
                        </span>
                      </div>
                      <input
                        type="number"
                        id="total-micrometer"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentMicrometer.distances.total}
                      />
                    </div>
                    <label htmlFor="LE"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          LE
                        </span>
                      </div>
                      <input
                        type="number"
                        id="LE-micrometer"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentMicrometer.distances.LE}
                      />
                    </div>
                    <label htmlFor="MD"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          MD
                        </span>
                      </div>
                      <input
                        type="number"
                        id="MD-micrometer"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentMicrometer.distances.MD}
                      />
                    </div>
                    <label htmlFor="TE"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          TE
                        </span>
                      </div>
                      <input
                        type="number"
                        id="TE-micrometer"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentMicrometer.distances.TE}
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="col">
                <div className="selectMicrometer inputMicroAttr">
                  <label htmlFor="tip-percent">Select Indicator</label>
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={this.decrementDistanceIndex}
                      >
                        -
                      </button>
                    </div>
                    <input
                      type="number"
                      className="form-control"
                      id="tip-percent"
                      value={currentDistance}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={this.incrementDistanceIndex}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <form class="text-center">
                  Distance from <b>indicator</b> pivot lines
                  <br />
                  (moving only one indicator at a time)
                  <br />
                  <div>
                    <label htmlFor="Total"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          {currentDistance}
                        </span>
                      </div>
                      <input
                        type="number"
                        id="total-indicator"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentIndicator.distances.total}
                      />
                    </div>
                    <label htmlFor="LE"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          Mic. 1
                        </span>
                      </div>
                      <input
                        type="number"
                        id="1-indicator"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentIndicator.distances[1]}
                      />
                    </div>
                    <label htmlFor="MD"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          Mic. 2
                        </span>
                      </div>
                      <input
                        type="number"
                        id="2-indicator"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentIndicator.distances[2]}
                      />
                    </div>
                    <label htmlFor="TE"></label>
                    <div className="input-group inputMicroAttr">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          Mic. 3
                        </span>
                      </div>
                      <input
                        type="number"
                        id="3-indicator"
                        className="form-control text-right"
                        onChange={(e) => this.handleChange(e)}
                        value={this.state.currentIndicator.distances[3]}
                      />
                    </div>
                  </div>
                </form>
              </div>

              {/* <div className="col">
            <div className="row align-items-center" style={divStyle}>
              <div className="col-6">
                <h2>Tip</h2>
                <h2>Total</h2>
              </div>
              <div className="col-6">
                <h2>${this.state.tipAmount.toFixed(2)}</h2>
                <h2>${this.state.totalAmount.toFixed(2)}</h2>
              </div>
            </div>
          </div>
          <div className="col"></div>
          <div className="col"></div> */}
            </div>
            <div className="row">
            <br/>
          <img className="image" src={micrometerImage} alt="Logo" />
          </div>
          </div>
          <br />
          <div className="row">
            <div className={this.state.configMinimized ? "hidden" : ""}>
              <div className="col">
                <button className="btn btn-secondary" onClick={this.minimize}>
                  <div className="">Minimize Configuration</div>
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <form class="text-center">
                <h5>
                  Indicator <b> current</b> reading
                </h5>
                <div>
                  <label htmlFor="LE" />
                  <div className="input-group inputMicroAttr">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        LE
                      </span>
                    </div>
                    <input
                      type="number"
                      id="LE-current"
                      className="form-control text-right"
                      onChange={(e) => this.handleReadingChange(e)}
                      value={this.state.currentReading[1]}
                    />
                  </div>
                  <label htmlFor="MD"></label>
                  <div className="input-group inputMicroAttr">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        MD
                      </span>
                    </div>
                    <input
                      type="number"
                      id="MD-current"
                      className="form-control text-right"
                      onChange={(e) => this.handleReadingChange(e)}
                      value={this.state.currentReading[2]}
                    />
                  </div>
                  <label htmlFor="TE"></label>
                  <div className="input-group inputMicroAttr">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        TE
                      </span>
                    </div>
                    <input
                      type="number"
                      id="TE-current"
                      className="form-control text-right"
                      onChange={(e) => this.handleReadingChange(e)}
                      value={this.state.currentReading[3]}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="col">
              <form class="text-center">
                <h5>
                  Indicator <b> desired</b> reading
                </h5>
                <div className="">
                  <label htmlFor="LE"></label>
                  <div className="input-group inputMicroAttr">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        LE
                      </span>
                    </div>
                    <input
                      type="number"
                      id="LE-desired"
                      className="form-control text-right"
                      onChange={(e) => this.handleReadingChange(e)}
                      value={this.state.desiredReading[1]}
                    />
                  </div>
                  <label htmlFor="MD"></label>
                  <div className="input-group inputMicroAttr">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        MD
                      </span>
                    </div>
                    <input
                      type="number"
                      id="MD-desired"
                      className="form-control text-right"
                      onChange={(e) => this.handleReadingChange(e)}
                      value={this.state.desiredReading[2]}
                    />
                  </div>
                  <label htmlFor="TE"></label>
                  <div className="input-group inputMicroAttr">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        TE
                      </span>
                    </div>
                    <input
                      type="number"
                      id="TE-desired"
                      className="form-control text-right"
                      onChange={(e) => this.handleReadingChange(e)}
                      value={this.state.desiredReading[3]}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="row" />
          <br />
          <div className="row">
            <div className="col">
              <section>
                <h4 className="text-center" >micrometer changes table</h4>
                <table id="changesTable" className="inputMicroAttr">
                  <thead>
                    <tr>
                      <th>Mic.</th>
                      <th>LE</th>
                      <th>MD</th>
                      <th>TE</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.micrometers.map((item) => (
                      <tr key={item.id}>
                        <td className="tableData text-center">{item.id}</td>
                        {item.changesToMake.map((row) => (
                          <td className="tableData text-center" key={row.id}>{row.value}</td>
                        ))}
                        <td>{item.changeToMakeTotal}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <section>
                <h1>Steps</h1>
                {this.state.steps.map((item) => (
                  <div key={item.id}>
                    <label className="text-center" htmlFor={item.id}>{item.description} </label>
                    <br/>
                    <div className="inputMicroAttr text-center"><b> {item.value}</b>
                    </div>
                  </div>
                ))}
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

render(<MicrometerCalculator />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js